import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { flexCenterDir, fullPage, pageSetting } from "../styles/theme";

const Main = () => {
	return (
		<MainSection>
			<LogoSection>
				<GradientCir>
					<div className="circle"></div>
					<img src="/logo1.png" alt="logo" />
				</GradientCir>
			</LogoSection>
			<DescriptSection>
				<Descriptor>
					<h2>Request BugBounty</h2>
				</Descriptor>
				<Descriptor style={{ justifyContent: "flex-end" }}>
					<BountyBox>
						<h2>Bounty List</h2>
						<span>
							Wormhole is a generic cross-chain messaging protocol that allows smart contracts on
							various blockchains to communicate with each other. Messages are routed from chain to
							chain by a decentralised group of guardian nodes who sign attestations of on-chain
							state. For more information about Wormhole, please visit https://wormhole.com/. This
							bug bounty program is focused on the prevention of negative impacts to Wormhole and
							the Portal Token Bridge, which currently covers their smart contracts, guardian nodes,
							and Wormhole integrations with blockchains.
						</span>
						<GradientBtn to="/bountyList">
							<button>
								Go to Bounty List
								<div className="fill"></div>
							</button>
						</GradientBtn>
					</BountyBox>
				</Descriptor>
				<Descriptor>
					<h2>Dashboard</h2>
				</Descriptor>
			</DescriptSection>
		</MainSection>
	);
};

const MainSection = styled.main`
	${flexCenterDir}
`;

const LogoSection = styled.section`
	${fullPage}

	position: relative;

	img {
		width: 45rem;
	}
`;

const GradientCir = styled.div`
	position: absolute;
	top: 15%;
	left: 29%;

	img {
		position: absolute;
	}

	.circle {
		position: absolute;
		width: 35rem;
		height: 35rem;
		border-radius: 50%;
		filter: blur(1rem);
		background-image: linear-gradient(to right, #e040fb, #783ebf, #a03d13);
		background-size: 150% 150%;

		-webkit-animation: gradient 3s ease infinite;
		-moz-animation: gradient 3s ease infinite;
		animation: gradient 3s ease infinite;

		@-webkit-keyframes gradient {
			0% {
				background-position: 0% 50%;
			}
			50% {
				background-position: 100% 50%;
			}
			100% {
				background-position: 0% 50%;
			}
		}

		@-moz-keyframes gradient {
			0% {
				background-position: 0% 50%;
			}
			50% {
				background-position: 100% 50%;
			}
			100% {
				background-position: 0% 50%;
			}
		}

		@keyframes gradient {
			0% {
				background-position: 0% 50%;
			}
			50% {
				background-position: 100% 50%;
			}
			100% {
				background-position: 0% 50%;
			}
		}
	}
`;

const DescriptSection = styled.ul`
	${pageSetting}

	scroll-snap-type: y mandatory;
`;

const Descriptor = styled.li`
	${fullPage}

	scroll-snap-align: center;
`;

const BountyBox = styled.div`
	${flexCenterDir}

	justify-content: flex-start;
	width: 60%;
	height: 80%;
	background: #262626;
	padding: 2.5rem;
	box-sizing: border-box;

	h2 {
		font-size: 4rem;
		line-height: 3rem;
	}

	span {
		font-size: 1rem;
		line-height: 2rem;
	}
`;

const GradientBtn = styled(Link)`
	text-align: center;
	position: relative;
	width: 300px;
	cursor: pointer;
	z-index: 1;
	margin-top: 3rem;

	button {
		position: relative;
		height: 50px;
		width: 23.75rem;
		border: 0;
		border-radius: 5px;
		text-transform: uppercase;
		font-size: 1.1em;
		letter-spacing: 0.2em;
		overflow: hidden;
		box-shadow: 0 4px 12px 0 rgba(152, 160, 180, 2);
		z-index: -2;
	}

	.fill {
		position: absolute;
		background-image: linear-gradient(to right, #e040fb, #4bdb17);
		background-size: 150% 150%;
		height: 70px;
		width: 33rem;
		border-radius: 5px;
		margin: -50px 0 0 -140px;
		z-index: -1;
		transition: all 0.4s ease;
	}

	&:hover .fill {
		-webkit-animation: gradient 3s ease infinite;
		-moz-animation: gradient 3s ease infinite;
		animation: gradient 3s ease infinite;
	}

	@-webkit-keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}

	@-moz-keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}

	@keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
`;

export default Main;
